(function () {
  const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
  const DIAS = ['Lu','Ma','Mi','Ju','Vi','Sá','Do'];

  function isoDay(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  class TalleresCalendarHub extends HTMLElement {
    constructor() {
      super();
      const dataEl = this.querySelector('script[data-sessions]');
      let sessions = [];
      try {
        sessions = JSON.parse(dataEl ? dataEl.textContent : '[]');
      } catch (e) {
        console.error('talleres-calendar-hub: JSON de sesiones inválido', e);
      }

      const now = new Date();
      this.sessions = sessions
        .map((s) => ({ ...s, dateObj: new Date(s.date) }))
        .filter((s) => !isNaN(s.dateObj) && s.dateObj >= new Date(now.getFullYear(), now.getMonth(), now.getDate()))
        .sort((a, b) => a.dateObj - b.dateObj);

      this.monthCursor = this.sessions.length
        ? new Date(this.sessions[0].dateObj.getFullYear(), this.sessions[0].dateObj.getMonth(), 1)
        : new Date(now.getFullYear(), now.getMonth(), 1);

            this.selectedDay = this.sessions.length ? isoDay(this.sessions[0].dateObj) : null;

      this.monthEl = this.querySelector('.talleres-hub__cal-month');
      this.gridEl = this.querySelector('.talleres-hub__cal-grid');
      this.listEl = this.querySelector('.talleres-hub__list');
      this.listHeadingEl = this.querySelector('.talleres-hub__list-heading');
      this.prevBtn = this.querySelector('.talleres-hub__cal-prev');
      this.nextBtn = this.querySelector('.talleres-hub__cal-next');

      this.prevBtn.addEventListener('click', () => this.changeMonth(-1));
      this.nextBtn.addEventListener('click', () => this.changeMonth(1));

      this.gridEl.addEventListener('click', (e) => {
        const cell = e.target.closest('td[data-day]');
        if (!cell) return;
        const day = cell.getAttribute('data-day');
        this.selectedDay = this.selectedDay === day ? null : day;
        this.render();
      });

      this.render();
    }

    changeMonth(delta) {
      this.monthCursor = new Date(this.monthCursor.getFullYear(), this.monthCursor.getMonth() + delta, 1);
      this.selectedDay = null;
      this.render();
    }

    sessionsForDay(date) {
      const target = isoDay(date);
      return this.sessions.filter((s) => isoDay(s.dateObj) === target);
    }

    render() {
      this.renderGrid();
      this.renderList();
    }

    renderGrid() {
      const year = this.monthCursor.getFullYear();
      const month = this.monthCursor.getMonth();
      this.monthEl.textContent = `${MESES[month]} ${year}`;

      const today = new Date();
      const isCurrentOrPast = year === today.getFullYear() && month <= today.getMonth();
      this.prevBtn.disabled = isCurrentOrPast && (year < today.getFullYear() || month <= today.getMonth());

      const firstDay = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const firstWeekday = (firstDay.getDay() + 6) % 7;

      let html = '<table class="talleres-hub__cal-table"><thead><tr>';
      DIAS.forEach((d) => (html += `<th>${d}</th>`));
      html += '</tr></thead><tbody><tr>';

      for (let i = 0; i < firstWeekday; i++) html += '<td></td>';

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        const dayKey = isoDay(date);
        const daySessions = this.sessionsForDay(date);
        const hasSession = daySessions.length > 0;

        const isToday =
          date.getFullYear() === today.getFullYear() &&
          date.getMonth() === today.getMonth() &&
          date.getDate() === today.getDate();
        const isSelected = this.selectedDay === dayKey;

                let sessionClass = '';
        if (hasSession) {
          sessionClass = daySessions.some((s) => s.available) ? 'has-available' : 'has-full';
        }

        const classes = [
          isToday && !hasSession ? 'is-today' : '',
          isSelected ? 'is-selected' : '',
          hasSession ? 'has-session' : '',
          sessionClass,
        ]
          .filter(Boolean)
          .join(' ');

        html += `<td class="${classes}" ${hasSession ? `data-day="${dayKey}"` : ''}><span class="day-num">${day}</span></td>`;

        if ((firstWeekday + day) % 7 === 0 && day !== daysInMonth) html += '</tr><tr>';
      }
      html += '</tr></tbody></table>';
      this.gridEl.innerHTML = html;
    }

    renderList() {
      let sessionsToShow;
      let heading;

      if (this.selectedDay) {
        sessionsToShow = this.sessions.filter((s) => isoDay(s.dateObj) === this.selectedDay);
        const [y, m, d] = this.selectedDay.split('-').map(Number);
        const dateObj = new Date(y, m - 1, d);
        const diaSemana = dateObj.toLocaleDateString('es-ES', { weekday: 'long' });
        heading = `${diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1)}, ${d} de ${MESES[m - 1].toLowerCase()}`;
      } else {
        this.listHeadingEl.textContent = '';
        this.listEl.innerHTML =
          '<li class="talleres-hub__list-empty talleres-hub__list-placeholder">Selecciona un día para ver los talleres disponibles.</li>';
        return;
      }

      this.listHeadingEl.textContent = heading;

      if (!sessionsToShow.length) {
        this.listEl.innerHTML = '<li class="talleres-hub__list-empty">No hay talleres ese día.</li>';
        return;
      }

            this.listEl.innerHTML = sessionsToShow
        .map((s) => {
          const hora = s.dateObj.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
          const url = `${s.productUrl}?variant=${s.variantId}`;
          const estado = s.available ? '' : ' <span class="talleres-hub__full-tag">Completo</span>';
          return `<li><a href="${url}"><strong class="s-h5 s-black">${s.workshopType}</strong> - ${hora} - ${s.location}${estado}</a></li>`;
        })
        .join('');
    }
  }

  customElements.define('talleres-calendar-hub', TalleresCalendarHub);
})();